import React, { Component } from "react";
import PropTypes from "prop-types";

import { isDefined, isNotDefined, noop } from "../utils";

import {
  getValueFromOverride,
  terminate,
  saveNodeType,
  isHoverForInteractiveType,
} from "./utils";

import EachLinhaCruzada from "./wrapper/EachLinhaCruzada";
import MouseLocationIndicator from "./components/MouseLocationIndicator";
import HoverTextNearMouse from "./components/HoverTextNearMouse";

class LinhasCruzadas extends Component {
  constructor(props) {
    super(props);

    this.handleStart = this.handleStart.bind(this);
    this.handleDrawCrossline = this.handleDrawCrossline.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
    this.handleDragCrossline = this.handleDragCrossline.bind(this);
    this.handleDragCrosslineComplete =
      this.handleDragCrosslineComplete.bind(this);

    this.terminate = terminate.bind(this);
    this.saveNodeType = saveNodeType.bind(this);

    this.getSelectionState = isHoverForInteractiveType("crosslines").bind(this);

    this.state = {};
    this.nodes = [];
  }

  handleDragCrossline(index, newValues) {
    this.setState({
      override: {
        index,
        ...newValues,
      },
    });
  }

  handleDragCrosslineComplete(moreProps) {
    const { override } = this.state;
    if (isDefined(override)) {
      const { crosslines } = this.props;
      const newCrosslines = crosslines.map((each, idx) =>
        idx === override.index
          ? {
              ...each,
              xValue: override.xValue,
              yValue: override.yValue,
              selected: true,
            }
          : {
              ...each,
              selected: false,
            },
      );

      this.setState(
        {
          override: null,
        },
        () => {
          this.props.onComplete(newCrosslines, moreProps);
        },
      );
    }
  }

  handleStart(xyValue, moreProps, e) {
    const { enabled } = this.props;
    if (!enabled) return;

    const { current } = this.state;

    if (
      isNotDefined(current) ||
      isNotDefined(current.xValue) ||
      isNotDefined(current.yValue)
    ) {
      this.setState(
        {
          current: {
            xValue: xyValue[0],
            yValue: xyValue[1],
          },
        },
        () => {
          this.props.onStart(moreProps, e);
        },
      );
    }
  }

  handleDrawCrossline(xyValue) {
    const { current } = this.state;
    if (
      isDefined(current) &&
      isDefined(current.xValue) &&
      isDefined(current.yValue)
    ) {
      this.setState({
        current: {
          xValue: xyValue[0],
          yValue: xyValue[1],
        },
      });
    }
  }

  handleEnd(xyValue, moreProps, e) {
    const { enabled, crosslines, appearance } = this.props;
    if (!enabled) return;

    const xValue = xyValue[0];
    const yValue = xyValue[1];

    const newCrosslines = [
      ...crosslines.map((d) => ({ ...d, selected: false })),
      {
        xValue,
        yValue,
        selected: true,
        appearance,
      },
    ];

    this.setState(
      {
        current: null,
      },
      () => {
        this.props.onComplete(newCrosslines, moreProps, e);
      },
    );
  }

  render() {
    const { appearance, crosslines, hoverText } = this.props;
    const { enabled, snap, shouldDisableSnap, snapTo } = this.props;
    const { currentPositionRadius, currentPositionStroke } = this.props;
    const { currentPositionstrokeOpacity, currentPositionStrokeWidth } =
      this.props;
    const { current, override } = this.state;

    const tempCrossline = isDefined(current) ? (
      <EachLinhaCruzada
        interactive={false}
        xValue={current.xValue}
        yValue={current.yValue}
        stroke={
          appearance.stroke && typeof appearance.stroke === "object"
            ? appearance.stroke.color || "#000000"
            : appearance.stroke || "#000000"
        }
        strokeWidth={
          appearance.stroke && typeof appearance.stroke === "object"
            ? appearance.stroke.width || 1
            : appearance.strokeWidth || 1
        }
        strokeOpacity={
          appearance.stroke && typeof appearance.stroke === "object"
            ? appearance.stroke.opacity !== undefined
              ? appearance.stroke.opacity
              : 1
            : appearance.strokeOpacity !== undefined
              ? appearance.strokeOpacity
              : 1
        }
        strokeDasharray={
          appearance.stroke &&
          typeof appearance.stroke === "object" &&
          appearance.stroke.dash
            ? appearance.stroke.dash
            : "Solid"
        }
      />
    ) : null;

    return (
      <g>
        {crosslines.map((each, idx) => {
          let eachAppearance = appearance;
          if (isDefined(each.appearance)) {
            eachAppearance = { ...appearance };
            if (
              each.appearance.stroke &&
              typeof each.appearance.stroke === "object"
            ) {
              eachAppearance.stroke = {
                ...(appearance.stroke || {}),
                ...(each.appearance.stroke || {}),
              };
            } else if (each.appearance.stroke) {
              eachAppearance.stroke = each.appearance.stroke;
            }
          }

          const hoverTextWithDefault = {
            ...LinhasCruzadas.defaultProps.hoverText,
            ...hoverText,
          };

          return (
            <EachLinhaCruzada
              key={idx}
              ref={this.saveNodeType(idx)}
              index={idx}
              selected={each.selected}
              xValue={getValueFromOverride(
                override,
                idx,
                "xValue",
                each.xValue,
              )}
              yValue={getValueFromOverride(
                override,
                idx,
                "yValue",
                each.yValue,
              )}
              stroke={
                eachAppearance.stroke &&
                typeof eachAppearance.stroke === "object"
                  ? eachAppearance.stroke.color || "#000000"
                  : eachAppearance.stroke || "#000000"
              }
              strokeWidth={
                eachAppearance.stroke &&
                typeof eachAppearance.stroke === "object"
                  ? eachAppearance.stroke.width || 1
                  : eachAppearance.strokeWidth || 1
              }
              strokeOpacity={
                eachAppearance.stroke &&
                typeof eachAppearance.stroke === "object"
                  ? eachAppearance.stroke.opacity !== undefined
                    ? eachAppearance.stroke.opacity
                    : 1
                  : eachAppearance.strokeOpacity !== undefined
                    ? eachAppearance.strokeOpacity
                    : 1
              }
              strokeDasharray={
                eachAppearance.stroke &&
                typeof eachAppearance.stroke === "object" &&
                eachAppearance.stroke.dash
                  ? eachAppearance.stroke.dash
                  : "Solid"
              }
              onDrag={this.handleDragCrossline}
              onDragComplete={this.handleDragCrosslineComplete}
              hoverText={hoverTextWithDefault}
            />
          );
        })}
        {tempCrossline}
        <MouseLocationIndicator
          enabled={enabled}
          snap={snap}
          shouldDisableSnap={shouldDisableSnap}
          snapTo={snapTo}
          r={currentPositionRadius}
          stroke={currentPositionStroke}
          strokeOpacity={currentPositionstrokeOpacity}
          strokeWidth={currentPositionStrokeWidth}
          onMouseDown={this.handleStart}
          onMouseMove={this.handleDrawCrossline}
          onClick={this.handleEnd}
          data-evo-id="interactive-linhas-cruzadas"
        />
      </g>
    );
  }
}

LinhasCruzadas.propTypes = {
  enabled: PropTypes.bool.isRequired,
  onStart: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  onSelect: PropTypes.func,
  snap: PropTypes.bool,
  snapTo: PropTypes.func,
  shouldDisableSnap: PropTypes.func.isRequired,

  currentPositionStroke: PropTypes.string,
  currentPositionStrokeWidth: PropTypes.number,
  currentPositionstrokeOpacity: PropTypes.number,
  currentPositionRadius: PropTypes.number,

  hoverText: PropTypes.object,

  crosslines: PropTypes.array.isRequired,

  appearance: PropTypes.shape({
    stroke: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        color: PropTypes.string,
        dash: PropTypes.string,
        width: PropTypes.number,
        opacity: PropTypes.number,
      }),
    ]),
  }).isRequired,
};

LinhasCruzadas.defaultProps = {
  onStart: noop,
  onComplete: noop,
  onSelect: noop,
  shouldDisableSnap: () => true,
  snap: false,

  currentPositionStroke: "#000000",
  currentPositionstrokeOpacity: 1,
  currentPositionStrokeWidth: 3,
  currentPositionRadius: 4,

  hoverText: {
    ...HoverTextNearMouse.defaultProps,
    enable: false,
    bgHeight: "auto",
    bgWidth: "auto",
    text: "Clique para selecionar",
    selectedText: "",
  },

  crosslines: [],

  appearance: {
    stroke: {
      color: "#2196F3",
      width: 2,
      opacity: 1,
      dash: "Solid",
    },
  },
};

export default LinhasCruzadas;
